import { Fragment, useEffect, useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { Box, Grid, Step, StepLabel, Stepper, Typography } from "@mui/material";

import ChatGPT from "../../components/ChatGPT/ChatGPT";
import { useRespuesta } from "../../data/RespuestaContext";
import { useJobContext } from "../../hooks/Jobs";
import { useProyecto } from "../../data/ProyectoContext";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";

import NuevoABP from "../../components/NuevoABP/NuevoABP";
import PropuestasNuevoABP from "../../components/Propuestas/PropuestasNuevoABP";
import ComponentFormEtapasNuevoABP from "../../components/Form/Etapas/ComponentFormEtapasNuevoABP";
import HeaderApps from "../../components/UmmIACategories/Layout/HeaderApps";

import { useNavigate } from "react-router-dom";
import UnidadTematicaCardImg from "../../components/UmmIApps/Cards/ClaseActivaCardImg.png";

import LoadingOverlay from "../../components/Loading/LoadingOverlay";


const steps = [
  "Diseña\n tu planificación",
  "Explora\n las planificaciones",
  "Recibe\n tu planificación",
];


const NuevoABPPageInner = () => {
  const { etapa, isCompleted, resetState, handleSetTipoEstructuraProyecto } =
    useJobContext();

  const { respuesta } = useRespuesta();
  const [activeStep, setActiveStep] = useState(0);

  const { proyecto, setProyecto } = useProyecto();

  const {
    handleNivelChange,
    handleAsignaturaChangeLocal,
    setPromptData,
    setObjetivosSeleccionados,
    textoInicial,
  } = useActividadesContext();

  const navigate = useNavigate();
  const [isGeneratingPropuestas, setIsGeneratingPropuestas] = useState(false);

  const handleBack = () => {
    navigate("/asistente/ummiaplan");
  };

  const handleNext = () => {
    setIsGeneratingPropuestas(true);
    setActiveStep((prevStep) => prevStep + 1);
  };

  useEffect(() => {
    if (etapa === 0 && !isCompleted) {
      setActiveStep(0);
      setIsGeneratingPropuestas(false);
      startABP();
    } else {
      setActiveStep(etapa + 1);
    }
  }, [etapa]);

  useEffect(() => {
    if (isCompleted) {
      setIsGeneratingPropuestas(false);
    }
  }, [isCompleted]);

  const startABP = async () => {
    resetState();

    setProyecto({
      ...proyecto,
      tipo_estructura: "Aprendizaje basado en proyectos",
      materias: [],
      objetivos_aprendizaje_cn: [],
      objetivos_aprendizaje_org: [],
      objetivos_aprendizaje_tp: [],
    });

    setPromptData({});
    await handleNivelChange("", null);
    handleAsignaturaChangeLocal({ id: "", nombre: "" });
    setObjetivosSeleccionados({});
    handleSetTipoEstructuraProyecto("aprendizaje_basado_en_proyectos");
  };

  const StepperRight = (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        mt: 2,
      }}
    >
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        sx={{
          width: "30%",
          ml: "auto",
          "& .MuiStep-root": { p: 0 },
          "& .MuiStepConnector-root": { top: 16 },
          "& .MuiStepConnector-line": {
            borderColor: "#90AFC5",
            borderTopWidth: 6,
          },
          "& .MuiStepIcon-root": {
            color: "#90AFC5",
            fontSize: "2.6rem",
            fontFamily: "Montserrat",
            "&.Mui-active": { color: "#336B87" },
            "&.Mui-completed": { color: "#336B87" },
          },
          "& .MuiStepIcon-text": {
            fontFamily: "Montserrat",
            fontWeight: 700,
            fontSize: "0.7rem",
          },
          "& .MuiStepLabel-label": {
            mt: 1,
            fontFamily: "Montserrat",
            fontSize: "0.6rem",
            fontWeight: "800",
            color: "#90AFC5",
            textAlign: "center",
            whiteSpace: "pre-line",
          },
          "& .MuiStepLabel-label.Mui-active": {
            color: "#336B87",
            fontWeight: 700,
          },
        }}
      >
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );

  const HeaderStep = (
    <HeaderApps
      imageSrc={UnidadTematicaCardImg}
      backgroundColorImage={
        "linear-gradient(180deg, #FFFFFF 0%, #A9D1C0 100%, #52A381 100%)"
      }
      titleColor="#278C62"
      title="Planificación ABP PRUEBA"
      description="Diseña proyectos de Aprendizaje Basado en Problemas (ABP) de manera eficiente con UmmIA."
      onBack={handleBack}
      colorIconBack={"#52A381"}
    />
  );

  const Step1Inner = (
    <>
      {HeaderStep}
      {activeStep > 0 && StepperRight}

      <Grid sx={{ padding: 2, borderRadius: 3, border: "2px solid #336B87" }}>
        <Typography variant="body1" fontFamily={"montserrat"}>
          {textoInicial ??
            `Estas son las propuestas que tengo para ti.  Puedes revisarlas y modificarlas en cualquier parte según tus necesidades. Ajusta los parámetros en 'Mostrar campos', genera una nueva versión con 'Volver a generar' o personaliza el contenido con 'Editar'. Si prefieres trabajar en otra plataforma, usa 'Copiar' para llevar el texto donde desees.`}
        </Typography>
      </Grid>

      <ComponentFormEtapasNuevoABP
        color="#90AFC5"
        PropuestasComponent={PropuestasNuevoABP}
        key="abp_1"
      />
    </>
  );

  const stepContentMap = [
    <NuevoABP onNextStep={handleNext} key="abp_0" />,

    <Box key="abp_1_container" sx={{ position: "relative", minHeight: "100vh" }}>
      {Step1Inner}

      {isGeneratingPropuestas && !isCompleted && (
        <LoadingOverlay
          onComplete={() => {
            
          }}
        />
      )}
    </Box>,

    <Fragment key="abp_2">
      {HeaderStep}
      {activeStep > 0 && StepperRight}
      <ChatGPT respuestaData={respuesta?.propuestas} />
    </Fragment>,
  ];

  return (
    <Fragment>
      <CssBaseline />

      {activeStep === steps.length ? (
        <Typography variant="subtitle1">En construcción...</Typography>
      ) : (
        stepContentMap[activeStep]
      )}
    </Fragment>
  );
};


export default function NuevoABPPage() {


  return (
  
      <NuevoABPPageInner />
   
  );
}
